import MainView from './mainView.js';
import icons from 'url:../../img/icons.svg';

class PaginationView extends MainView {
  _parentElement = document.querySelector('.pagination');

  addHandlerPagination(handler) {
    this._parentElement.addEventListener('click', function (event) {
      const button = event.target.closest('.btn--inline');
      if (!button) return;
      const navigatePage = Number(button.dataset.navigatePage);
      handler(navigatePage);
    });
  }

  _generateMarkup() {
    const currentPage = this._data.page;
    const numPages = Math.ceil(
      this._data.results.length / this._data.resultsPerPage
    );
    //Page 1, no other pages
    if (currentPage === 1 && numPages === 1) {
      return '';
    }
    //Page 1, more pages
    if (currentPage === 1 && numPages > 1) {
      return this._generateButtonNext(currentPage);
    }
    //Last page
    if (currentPage === numPages && numPages > 1) {
      return this._generateButtonPrevious(currentPage);
    }
    //Other page
    if (currentPage != 1 && currentPage < numPages && numPages > 1) {
      const buttonPrevious = this._generateButtonPrevious(currentPage);
      const buttonNext = this._generateButtonNext(currentPage);
      return buttonPrevious + buttonNext;
    }
  }

  _generateButtonNext(currentPage) {
    const nextPage = currentPage + 1;
    return `
       <button data-navigate-page="${nextPage}" class="btn--inline pagination__btn--next">
         <span>Page ${nextPage}</span>
         <svg class="search__icon">
           <use href="${icons}#icon-arrow-right"></use>
         </svg>
       </button>`;
  }

  _generateButtonPrevious(currentPage) {
    const previousPage = currentPage - 1;
    return `
      <button data-navigate-page="${previousPage}" class="btn--inline pagination__btn--prev">
         <svg class="search__icon">
           <use href="${icons}#icon-arrow-left"></use>
         </svg>
         <span>Page ${previousPage}</span>
       </button>`;
  }
}

export default new PaginationView();
